<template>
  <div>
    <div class="row justify-content-end">


      <div class="col-auto">
        <button @click="refresh()" class="btn btn0 btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button @click="$router.push({ name: 'deliveries-create' })" class="btn btn-primary">
          <i class="bi bi-plus-square"></i>
          Créer une charge
        </button>
      </div>
    </div>
    <br />

    <!-- <vue-data-table :headers="headers" :data="deliveries" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns" /> -->

    <vue-data-table :headers="headers" :data="deliveries" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns">

      <template #cell-totalPriceTTC="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          :class="row.totalPriceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #cell-validated="{ row }">
        <span class="px-2 py-1 rounded  "
          :class="row.validated == 'Validé' ? 'bg-light-success text-success' : 'bg-light-danger text-danger'">
          {{ row.validated }}
        </span>
      </template>

      <!-- <template #cell-exit="{ row }">
        <span class="px-2 py-1 rounded  "
          :class="row.exit == 'En charge' ? 'bg-light-warning text-warning' : 'bg-light-success text-danger'">
          {{ row.exit }}
        </span>
      </template> -->

      <template #cell-exit="{ row }">
        <span class="px-2 py-1 rounded" :class="{
          'bg-light-warning text-warning': row.deliveryDateTime === null,
          'bg-light-success text-danger': row.deliveryDateTime !== null
        }">
          {{ row.deliveryDateTime === null ? 'En charge' : 'En attente d\'expédié' }}
        </span>
      </template>



      <template #cell-deliveryFullName="{ row }">
        <span class="px-2 py-1 rounded  " :class="row.deliveryFullName ? '' : 'bg-light-danger text-danger'">
          {{ row.deliveryFullName ? row.deliveryFullName : "Non livré" }}
        </span>
      </template>

      <template #cell-startChargeDatetime="{ row }">
        <span class="px-2 py-1 rounded" :class="row.startChargeDatetime ? '' : 'bg-light-danger text-danger'">
          {{ row.startChargeDatetime ? formatDate(row.startChargeDatetime) : "Non livré" }}
        </span>
      </template>

      <template #cell-startChargeTime="{ row }">
        <span class="px-2 py-1 rounded" :class="row.startChargeDatetime ? '' : 'bg-light-danger text-danger'">
          {{ row.startChargeDatetime ? formatTime(row.startChargeDatetime) : "Non livré" }}
        </span>
      </template>

      <template #cell-deliveryDateTime="{ row }">
        <span class="px-2 py-1 rounded" :class="row.deliveryDateTime ? '' : 'bg-light-danger text-danger'">
          {{ row.deliveryDateTime ? formatDate(row.deliveryDateTime) : "Non livré" }}
        </span>
      </template>

      <template #cell-deliveryTime="{ row }">
        <span class="px-2 py-1 rounded" :class="row.deliveryDateTime ? '' : 'bg-light-danger text-danger'">
          {{ row.deliveryDateTime ? formatTime(row.deliveryDateTime) : "Non livré" }}
        </span>
      </template>


      <template #cell-vehicleFullName="{ row }">
        <span class="px-2 py-1 rounded  " :class="row.vehicleFullName ? '' : 'bg-light-danger text-danger'">
          {{ row.vehicleFullName ? row.vehicleFullName : "Non livré" }}
        </span>
      </template>

      <template #cell-passPermit="{ row }">
        <span class="px-2 py-1 rounded  ">
          {{ row.passPermit ? "LP" + row.passPermit : "Non livré" }}
        </span>
      </template>

      <template #cell-netWeight="{ row }">
        <span class="px-2 py-1 rounded  ">
          {{ parseFloat(row.grossWeight) - parseFloat(row.tareWeight) }}
        </span>
      </template>

      <template #cell-totalQuantity="{ row }">
        <span class="px-2 py-1 rounded  ">
          {{ parseFloat(row.totalQuantity) * 100 }}
        </span>
      </template>

      <template #cell-weightQuantityDiff="{ row }">
        <span class="px-2 py-1 rounded  " :class="(parseFloat(parseFloat(row.grossWeight) - parseFloat(row.tareWeight)) - parseFloat(row.totalQuantity) * 100) > 40
          ? 'bg-light-warning text-danger' :
          (parseFloat(parseFloat(row.grossWeight) - parseFloat(row.tareWeight)) - parseFloat(row.totalQuantity) * 100) < -40 ?
            'bg-light-danger text-danger' : 'bg-light-success text-success'">
          {{ parseFloat(parseFloat(row.grossWeight) - parseFloat(row.tareWeight)) - parseFloat(row.totalQuantity) * 100
          }}
        </span>
      </template>

      <template #cell-remark="{ row }">
        <span v-show="row.remark" class="px-2 py-1 rounded  " :class="row.remark ? 'bg-light-info text-info' : ''">
          <i class="bi bi-exclamation-circle-fill"></i>
        </span>
      </template>


      <template #footer-totalPriceTTC="{ column, sum }">
        <span v-show="$userRole != 'Magasinier'" class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>


    </vue-data-table>

  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      search_value: "",
      addedToday: false,
      sortValue: "",
      selections: [],
      headers: [
        { field: 'reference', label: 'Référence', class: '' },
        { field: 'startChargeDatetime', label: 'Entrée le', class: '' },
        { field: 'startChargeTime', label: 'Entrée à', class: '' },
        { field: 'deliveryDateTime', label: 'Sortie le', class: '' },
        { field: 'deliveryTime', label: 'Sortie à', class: '' },
        { field: 'employeeFullName', label: 'Chauffeur', class: '' },
        { field: 'vehicleFullName', label: 'Véhicule', class: '' },
        { field: 'tareWeight', label: 'Tare', class: '' },
        { field: 'grossWeight', label: 'Brut', class: '' },
        { field: 'netWeight', label: 'Poids Net', class: '' },
        { field: 'totalQuantity', label: 'Qté Totale', class: '' },
        { field: 'weightQuantityDiff', label: 'Différence Poids', class: '' },
        { field: 'numberOfOrders', label: 'Commandes', class: '' },
        { field: 'numberOfCustomers', label: 'Clients', class: '' }, // ← ajouté ici
        { field: 'exit', label: 'État', class: '' },
        { field: 'remark', label: 'NB', class: '' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],


      // Button actions
      buttons: [
        {
          label: 'Détails',
          icon: 'bi bi-info-square',
          class: 'btn btn-primary',
          action: (delivery) => {
            this.$router.push({
              name: 'deliveries-details',
              params: { reference: delivery.reference },
            });
          },
        },
      ],
      // Summable columns
      summableColumns: [
        { field: 'totalPriceTTC', class: 'fw-bold' },
        { field: 'totalQuantity', class: 'fw-bold' },
      ],

    };
  },
  computed: {
    ...mapGetters("delivery", {
      deliveries: "getAll",
    }),
  },
  mounted() {
    this.$store.dispatch("delivery/getAll");

    // setInterval(() => {
    //   this.$store.dispatch("delivery/getAll");
    // }, 3000);
  },
  methods: {

    async refresh() {
      this.$store.dispatch("delivery/getAll");
    },

  },
  methods: {
    formatDate(value) {
      if (!value) return null;
      return moment(value).format("DD-MM-YYYY");
    },
    formatTime(value) {
      if (!value) return null;
      return moment(value).format("HH:mm"); // Correction du format d'heure
    }
  }

};
</script>
